<template>
  <div ref="topContainer">
    <div v-show="!isSurgConfirm">
      <section
        class="
                mobile_add_new_head
                bg--blue
                tx--bege
                center
                flex flex--content--center
                relative
              "
      >
        <div class="title">
          {{ editSurgery ? "עריכת" : "יצירת" }} תור לניתוח
        </div>
        <a
          class="m_bt_head head_cancel"
          href="javascript:void(0)"
          @click="$router.go(-1)"
        >
          ביטול
        </a>
        <a
          class="m_bt_head head_save"
          href="javascript:void(0)"
          @click.prevent="confirmSurg"
        >
          הבא
        </a>
      </section>

      <section
        class="add_new_head white--body tx--bege relative cover m_bg_blue no_mobile"
        style="background-image:url('/assets/img/layout/bg_serg.jpg');"
      >
        <div class="popup_close close-animate">
          <a @click="goBackRoute">
            <CloseSvg />
          </a>
        </div>
        <a
          v-show="editSurgery ? (stage == 2 ? false : true) : true"
          class="no_mobile link_goback"
          @click="onPrevStage"
        >
          חזרה
          <ArrowBack />
        </a>
        <div class="inner_width flex flex--column center">
          <h1 class="title">
            <span class="bold"
              >{{ editSurgery ? "עריכת" : "יצירת" }} ניתוח לשיבוץ -</span
            >{{ activeDoctor.name }}
          </h1>
          <div class="add_step_all flex flex--content--center">
            <div class="add_step_all flex flex--content--center">
              <div class="add_step" :class="stage < 1 ? '' : 'active'">1</div>
              <div class="add_step" :class="stage < 2 ? '' : 'active'">2</div>
              <div class="add_step" :class="stage < 3 ? '' : 'active'">3</div>
              <div class="add_step" :class="stage < 4 ? '' : 'active'">4</div>
            </div>
          </div>
        </div>
      </section>

      <ValidationObserver ref="surgform">
        <form
          v-if="doctorHistory"
          @submit.prevent="confirmSurg"
          name="surgeryForm"
          class="surgeryFormEl"
        >
          <section class="add_new_inner wrap-surg-add">
            <!-- Stage 2 -->
            <div
              class="subtitle center no_mobile"
              v-if="stage === 2 || isMobile"
            >
              הזן פרטי מטופל
            </div>
            <h2 v-show="isMobile" class="subtitle_inner">
              הזן פרטי מטופל:
            </h2>
            <input type="hidden" name="passport" v-model="surg.id_num" />
            <div
              v-if="stage === 2 || isMobile"
              class="inner_group bg--white desk_inner_width desk-flex desk-flex--top desk-flex--start split-4 desk-no-pad"
            >
              <div class="add_new_row flex">
                <div class="add_new_row_col1">שם משפחה*</div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="last_name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        type="text"
                        name="last_name"
                        v-model="surg.last_name"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">שם פרטי*</div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="first_name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        type="text"
                        name="first_name"
                        v-model="surg.first_name"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">
                  תאריך לידה*
                  <span class="note mobile_only">לצורך חישוב גיל</span>
                </div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="birth_date"
                    rules="required|birth_date"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity tx--right">
                      <input
                        id="birth_date"
                        type="text"
                        name="birth_date"
                        placeholder="dd/mm/yyyy"
                        v-mask="['##/##/####']"
                        v-model="surg.birth_date"
                        autocomplete="off"
                      />
                    </div>
                    <span class="note no_mobile">לצורך חישוב גיל</span>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">שם אפוטרופוס</div>
                <div class="add_new_row_col2">
                  <div class="input-opacity">
                    <input type="text" v-model="surg.parent_name" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="stage === 2 || isMobile"
              class="inner_group bg--white desk_inner_width desk-flex desk-flex--top desk-flex--start split-4 desk-no-pad"
            >
              <div class="add_new_row flex">
                <div class="add_new_row_col1">
                  נייד*
                  <span class="note mobile_only">משמש כניסה לאזור אישי</span>
                </div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="phone"
                    mode="lazy"
                    :rules="{
                      required: true,
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        name="phone"
                        v-model="surg.phone"
                        type="tel"
                        autocomplete="off"
                      />
                    </div>
                    <span class="note no_mobile">משמש כניסה לאזור אישי</span>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">טלפון נוסף</div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="phone2"
                    mode="lazy"
                    :rules="{
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        name="phone2"
                        v-model="surg.phone2"
                        type="tel"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">שפה מועדפת</div>
                <div class="add_new_row_col2">
                  <div class="input-opacity" style="">
                    <select2 name="lang" id="" dir="rtl" v-model="surg.lang">
                      <option value="">בחירה</option>
                      <option value="hebrew">עברית</option>
                      <option value="english">אנגלית</option>
                      <option value="russian">רוסית</option>
                      <option value="arabic">ערבית</option>
                    </select2>
                  </div>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">מין המטופל*</div>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="gender"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity" style="">
                      <select2 name="gender" dir="rtl" v-model="surg.gender">
                        <option value="">בחר מין</option>
                        <option value="male">זכר</option>
                        <option value="female">נקבה</option>
                      </select2>
                    </div>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <!-- End Stage 2 -->

            <!-- Stage 3 -->
            <div
              class="subtitle center no_mobile"
              v-if="stage === 3 || isMobile"
            >
              הזן פרטי ניתוח
            </div>
            <h2 v-show="isMobile" class="subtitle_inner">
              הזן פרטי ניתוח:
            </h2>
            <!-- Stage 3 - line 1 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width active"
              ref="selected_surgery"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
                ><span class="title"
                  >פרטי ניתוח מתוכנן (או מס׳ פעולות לניתוח)**</span
                >
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open toggleInner" style="display:block">
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">צד</div>
                  <div class="surg_list-2">תחום</div>
                  <div class="surg_list-3">שם/קוד ניתוח (בי״ח)*</div>
                  <div class="surg_list-4">שם/קוד ניתוח (קליני ICD9)*</div>
                  <div class="surg_list-5">משך (ברוטו)*</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.selected_surgery"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{
                      `${info.side} | ${getCategoryNameByCode(info.category)} ${
                        info.code_name_hospital
                      } ${info.code_name_clinical} ${info.duration} `
                    }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">{{ `${info.side}` }}</div>
                    <div class="surg_list-2">
                      {{ `${getCategoryNameByCode(info.category)}` }}
                    </div>
                    <div class="surg_list-3">
                      {{ `${info.code_name_hospital}` }}
                    </div>
                    <div class="surg_list-4">
                      {{ `${info.code_name_clinical}` }}
                    </div>
                    <div class="surg_list-5">{{ `${info.duration}` }}</div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('surgery', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="removeSelectedBlock('surgery', index)"
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <!-- <a
                        class="date_choose desk-hide"
                        onclick="showSelect(this)"
                        href="javascript:void(0)"
                        >בחירה</a
                      > -->
                      <div class="input-opacity desk-block">
                        <select2 dir="rtl" v-model="surg_info.side">
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-2">
                    <div class="add_new_row_col1 desk-hide">תחום</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2 name="" dir="rtl" v-model="surg_info.category">
                          <option value="">בחר תחום</option>
                          <option
                            :value="row.current_surgery_category_code"
                            v-for="(row, index) in surgery_categories"
                            :key="
                              index + '-' + row.current_surgery_category_name
                            "
                          >
                            {{ row.current_surgery_category_name }}
                          </option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם/קוד ניתוח (בי״ח)*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity relative"
                        :class="
                          surg_info.code_name_hospital &&
                          isEnglish(surg_info.code_name_hospital)
                            ? 'left-multiselect'
                            : 'right-multiselect'
                        "
                      >
                        <div
                          v-show="
                            surg_info.code_name_hospital !== '' &&
                              !disabledByAutocomplete.hospital
                          "
                          @click="resetValue('code_name_hospital')"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder="בחר/הקלד שם/קוד ניתוח"
                          v-model="surg_info.code_name_hospital"
                          @search-change="onSearch($event, 'current_surgery')"
                          :options="
                            surgery_codes_auto.length
                              ? surgery_codes_auto
                              : surgery_codes
                          "
                          :searchable="true"
                          :disabled="
                            !surgery_codes ||
                              !surgery_codes.length ||
                              disabledByAutocomplete.hospital
                          "
                          :allow-empty="false"
                          :options-limit="limit.current_surgery"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-4">
                    <div class="add_new_row_col1 desk-hide">
                      שם/קוד ניתוח<br />
                      (קליני ICD9)*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity relative"
                        :class="
                          surg_info.code_name_clinical &&
                          isEnglish(surg_info.code_name_clinical)
                            ? 'left-multiselect'
                            : 'right-multiselect'
                        "
                      >
                        <div
                          v-show="
                            surg_info.code_name_clinical !== '' &&
                              !disabledByAutocomplete.clinical
                          "
                          @click="resetValue('code_name_clinical')"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder="בחר/הקלד שם/קוד ניתוח קליני"
                          v-model="surg_info.code_name_clinical"
                          @search-change="onSearch($event, 'current_procedure')"
                          :options="
                            surgery_codes_clinic_auto.length
                              ? surgery_codes_clinic_auto
                              : surgery_codes_clinic
                          "
                          :searchable="true"
                          :disabled="
                            !surgery_codes_clinic ||
                              !surgery_codes_clinic.length ||
                              disabledByAutocomplete.clinical
                          "
                          :allow-empty="false"
                          :options-limit="limit.current_procedure"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 desk-hide">משך (ברוטו)</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity surg-time">
                        <validation-provider
                          ref="end_time"
                          name="end_time"
                          :rules="{
                            requiredSurgTime: [surg_info.code_name_hospital],
                            timeFormat: [null],
                            interval: [null]
                          }"
                          v-slot="{ errors }"
                        >
                          <cleave
                            :value="surg_info.duration"
                            :options="options"
                            @input="onCleave"
                            @focus.native="e => e.target.select()"
                            name="time"
                          ></cleave>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex desk-w-100">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('surgery')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה
                      </a>
                      <span class="surg-side-note text--20"
                        >(בבחירת קוד פעולה זהה, יש לבחור 'צד')
                      </span>
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href="javascript:void(0)"
                        @click.prevent="removeSelectedBlock('surgery', index)"
                        v-if="surge_info_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.surgery.show"
                    >
                      {{ errorMessages.surgery.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 2 -->
            <div
              v-if="stage === 3 || isMobile"
              ref="insuranceType"
              class="book_surgery toggleContainer desk_inner_width"
              :class="this.isMobile ? '' : 'active'"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex">
                  <span>גורם משלם (יתכן ונדרש להזין גם קודים)**</span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>

              <div class="book_surgery_open toggleInner">
                <div
                  class="inner_group bg--white desk-no-pad desk-flex desk-flex--top desk-flex--start"
                >
                  <div class="add_new_row flex">
                    <div class="add_new_row_col1">
                      גורם משלם*
                      <span class="note mobile_only">בחר קופה מבטחת</span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <validation-provider
                          name="insurance_type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select2 dir="rtl" v-model="surg.insurance_type">
                            <option value="">בחר</option>
                            <option
                              v-for="insurance in insurance_types"
                              :key="insurance.insurance_name"
                              :value="insurance.insurance_name"
                            >
                              {{ insurance.insurance_name }}
                            </option>
                          </select2>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                      <span class="note no_mobile">בחר קופה מבטחת</span>
                    </div>
                  </div>
                  <div class="add_new_row flex">
                    <div class="add_new_row_col1">
                      שכר טרחה
                      <span class="note mobile_only"
                        >שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)</span
                      >
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity">
                        <!-- <validation-provider
                        name="doctor_fee"
                        rules="required"
                        v-slot="{ errors }"
                      > -->
                        <input
                          type="tel"
                          v-mask="'#'.repeat(10)"
                          v-model="surg.doctor_fee"
                          placeholder="₪"
                          autocomplete="off"
                        />
                        <!-- <span class="error-message">{{ errors[0] }}</span>
                      </validation-provider> -->
                      </div>
                      <span class="note no_mobile"
                        >שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 3 -->
            <div
              v-if="isInsuranceType && (stage === 3 || isMobile)"
              class="book_surgery toggleContainer desk_inner_width"
              :class="this.isMobile ? '' : 'active'"
              ref="insuranceSurg"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title">הזן פרטי ניתוח של גורם מבטח</span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div class="book_surgery_open toggleInner">
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">מבטח</div>
                  <div class="surg_list-2">תחום</div>
                  <div class="surg_list-3">שם/קוד ניתוח</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.insurance_surgery"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{
                      `${surg.insurance_type} | ${info.category} ${info.code} ${info.notes} `
                    }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">
                      {{ `${surg.insurance_type}` }}
                    </div>
                    <div class="surg_list-2">
                      {{ `${info.category}` }}
                    </div>
                    <div class="surg_list-3">
                      {{ `${info.code}` }}
                    </div>
                    <div class="surg_list-5">
                      {{ `${info.notes}` }}
                    </div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('insurance', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="removeSelectedBlock('insurance', index)"
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 w-100 desk-hide">מבטח</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="surg.insurance_type"
                        placeholder="מבטח"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-2">
                    <div class="add_new_row_col1 desk-hide">תחום</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <multiselect
                          placeholder=""
                          v-model="insurance_info.category"
                          :options="insurance_surgery_categories"
                          :searchable="true"
                          :allow-empty="false"
                          :disabled="
                            !insurance_surgery_categories ||
                              !insurance_surgery_categories.length
                          "
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם/קוד ניתוח
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity">
                        <multiselect
                          placeholder=""
                          v-model="insurance_info.code"
                          :options="insurance_surgery_codes"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.current_insurance"
                          :disabled="
                            !insurance_surgery_codes ||
                              !insurance_surgery_codes.length
                          "
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="insurance_info.notes"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex desk-w-100">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('insurance')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה</a
                      >
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href="javascript:void(0)"
                        @click.prevent="removeSelectedBlock('insurance', index)"
                        v-if="surge_info_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.insurance.show"
                    >
                      {{ errorMessages.insurance.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 4 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
                ><span class="title flex is--fit">
                  הסטוריית המחלה (אינדיקציה לניתוח ומחלה נוכחית)
                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open toggleInner" style="display: none;">
                <div class="inner_group bg--white desk-no-pad">
                  <div class="add_new_row flex desk-no-pad desk-w-100">
                    <div class="add_new_row_col1 w-100">
                      פרט מתי התחילו הסימפטומים, מתי אובחן, מה השיקול הרפואי
                      להחלטה על ניתוח זה, האם המחלה היא עקב גיל, עקב טראומה, עקב
                      ניתוח קודם שכשל
                    </div>
                    <div class="input_area_opcity textarea-big only-doc-mark">
                      <!-- <validation-provider
                      name="treatment_history"
                      rules="required"
                      v-slot="{ errors }"
                    > -->
                      <textarea
                        v-model="surg.treatment_history"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                      <!-- <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 5 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              ref="currentDiagnosis"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
                ><span class="title flex is--fit">
                  אבחנה נוכחית לפעולה (באנגלית)
                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>

              <div
                class="book_surgery_open  toggleInner"
                style="display: none;"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">צד</div>
                  <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
                  <div class="surg_list-3">קוד אבחנה</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.current_diagnosis"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{ `${info.side} | ${info.name} ` }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">{{ info.side }}</div>
                    <div class="surg_list-3">{{ info.name }}</div>
                    <div class="surg_list-3">{{ info.code }}</div>
                    <div class="surg_list-5">{{ info.notes }}</div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('diagnosis', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="removeSelectedBlock('diagnosis', index)"
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="diagnosis_info.side"
                        >
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם אבחנה*
                      <span class="note block">ניתן לחפש לפי קוד</span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="diagnosis_info.name !== ''"
                          @click="diagnosis_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="diagnosis_info.name"
                          @search-change="onSearch($event, 'current_diagnosis')"
                          :options="current_diagnosis"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.current_diagnosis"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <input disabled v-model="diagnosis_info.code" />
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="diagnosis_info.notes"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex desk-w-100">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('diagnosis')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה</a
                      >
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href="javascript:void(0)"
                        v-if="diagnosis_info_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.diagnosis.show"
                    >
                      {{ errorMessages.diagnosis.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 6 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              ref="past_diagnosis"
              :class="this.isMobile ? '' : 'active'"
            >
              <!-- <a
              class="book_surgery_top flex"
              href="javascript:void(0)"
              onclick="toggle(this)"
              ><span class="title"> אבחנות רקע*</span>
              <span class="plus-wrap flex m-flex--center"
                ><span class="plus"></span
              ></span>
              </a> -->
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    אבחנות רקע*
                    <span
                      class="surgery-check flex"
                      :class="{
                        active: surg.background_diagnosis == 'healthy'
                      }"
                      @click.stop="onHealty"
                    >
                      <span class="surgery-check-ic block"></span>
                      בריא בדרך כלל
                    </span>
                  </span>

                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>

                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open  toggleInner">
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">צד</div>
                  <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
                  <div class="surg_list-3">קוד אבחנה</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.past_diagnosis"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{ `${info.side} | ${info.diagnosis_name} ` }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">{{ info.side }}</div>
                    <div class="surg_list-3">{{ info.diagnosis_name }}</div>
                    <div class="surg_list-3">{{ info.diagnosis_number }}</div>
                    <div class="surg_list-5">{{ info.notice }}</div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('past_diagnosis', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="
                        removeSelectedBlock('past_diagnosis', index)
                      "
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="past_diagnosis.side"
                        >
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם אבחנה*
                      <span class="note block">ניתן לחפש לפי קוד</span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="past_diagnosis.diagnosis_name !== ''"
                          @click="past_diagnosis.diagnosis_name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="past_diagnosis.diagnosis_name"
                          @search-change="onSearch($event, 'past_diagnosis')"
                          :options="past_diagnosis_options"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.past_diagnosis"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <input
                          disabled
                          v-model="past_diagnosis.diagnosis_number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="past_diagnosis.notice"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex desk-w-100">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('past_diagnosis')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה</a
                      >
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href="javascript:void(0)"
                        v-if="past_diagnosis_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.past_diagnosis.show"
                    >
                      {{ errorMessages.past_diagnosis.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 7 -->
            <div
              v-if="stage === 3 || isMobile"
              ref="phisycal_check"
              class="book_surgery toggleContainer desk_inner_width"
              :class="this.isMobile ? '' : 'active'"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex is--fit">
                  <span>
                    בדיקה גופנית*
                  </span>
                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open toggleInner">
                <div class="inner_group bg--white desk-no-pad">
                  <div class="add_new_row flex desk-w-100 desk-no-pad">
                    <div class="add_new_row_col1 w-100">
                      פרט תוצאות בדיקה גופנית
                    </div>
                    <div class="input_area_opcity textarea-big only-doc-mark">
                      <validation-provider
                        name="phisycal_check"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <textarea
                          v-model="surg.phisycal_check"
                          placeholder="פירוט..."
                          autocomplete="off"
                        ></textarea>
                        <span class="error-message">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 8 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    רגישות לתרופות
                    <span
                      class="surgery-check flex"
                      :class="{ active: surg.no_drug_sens }"
                      @click.stop="surg.no_drug_sens = !surg.no_drug_sens"
                      ><span class="surgery-check-ic block"></span> לא ידועה
                      רגישות</span
                    >
                  </span>

                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open toggleInner" style="display: none;">
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">תגובה*</div>
                  <div class="surg_list-3">חומרה*</div>
                  <div class="surg_list-3">שם תרופה*</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.medication_sensitivity"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{
                      `${info.reaction} | ${info.severity} | ${info.name} | `
                    }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">{{ `${info.reaction}` }}</div>
                    <div class="surg_list-3 surg_list-rtl">
                      {{ `${info.severity}` }}
                    </div>
                    <div class="surg_list-3">{{ `${info.name}` }}</div>
                    <div class="surg_list-5">{{ info.notes }}</div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('medication', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="removeSelectedBlock('medication', index)"
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">תגובה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="medication_sensitivity_info.reaction"
                        >
                          <option value="">בחר תגובה</option>
                          <option>פריחה</option>
                          <option>גירוד</option>
                          <option>קוצר נשימה</option>
                          <option>כאבי בטן</option>
                          <option>רעד</option>
                          <option>הקאות</option>
                          <option>שלשולים</option>
                          <option>חולשה</option>
                          <option>ירידה ב-PLT</option>
                          <option>ירידת לחץ דם</option>
                          <option>נפיחות</option>
                          <option>הלם אנפילקטי</option>
                          <option>שוק</option>
                          <option>אנגיואדמה</option>
                          <option>חנק</option>
                          <option>אודם</option>
                          <option>אפניאה</option>
                          <option>בצקת</option>
                          <option>פרכוס</option>
                          <option>לא ידוע</option>
                          <option>אחר</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">חומרה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="medication_sensitivity_info.severity"
                        >
                          <option value="">בחר חומרה</option>
                          <option>קלה</option>
                          <option>בינוני</option>
                          <option>קשה</option>
                          <option>הלם</option>
                          <option>בספק</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">שם תרופה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="medication_sensitivity_info.name !== ''"
                          @click="medication_sensitivity_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="medication_sensitivity_info.name"
                          @search-change="
                            onSearch($event, 'medication_sensitivity')
                          "
                          :options="medication_sensitivity"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.medication_sensitivity"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="medication_sensitivity_info.notes"
                        placeholder="פירוט.."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex desk-w-100">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('medication')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה</a
                      >
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href=""
                        v-if="medication_sensitivity_info_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.medication.show"
                    >
                      {{ errorMessages.medication.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 9 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    רגישות לחומרים
                    <span
                      class="surgery-check flex"
                      :class="{ active: surg.no_material_sens }"
                      @click.stop="
                        surg.no_material_sens = !surg.no_material_sens
                      "
                      ><span class="surgery-check-ic block"></span> לא ידועה
                      רגישות</span
                    >
                  </span>

                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>
              <div class="book_surgery_open toggleInner" style="display: none;">
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">תגובה*</div>
                  <div class="surg_list-3">חומרה*</div>
                  <div class="surg_list-3">שם חומר (בעברית)*</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <div
                  class="edit_app_info flex flex--top"
                  v-for="(info, index) in surg.material_sensitivity"
                  :key="index"
                >
                  <div class="edit_app_info1 mobile_only">
                    {{
                      `${info.reaction} | ${info.severity} | ${info.name} | `
                    }}
                  </div>
                  <div class="edit_app_info1 no_mobile desk-flex">
                    <div class="surg_list-1">{{ `${info.reaction}` }}</div>
                    <div class="surg_list-3 surg_list-rtl">
                      {{ `${info.severity}` }}
                    </div>
                    <div class="surg_list-3">{{ info.name }}</div>
                    <div class="surg_list-5">{{ info.notes }}</div>
                  </div>
                  <div class="edit_app_info2 flex flex--end">
                    <a
                      class="edit_pen svg-block"
                      href="javascript:void(0)"
                      @click="editSelectedBlock('material', index)"
                    >
                      <PenSvg />
                    </a>
                    <a
                      class="edit_close_sur"
                      href="javascript:void(0);"
                      @click.prevent="removeSelectedBlock('material', index)"
                    >
                      <CloseSvg />
                    </a>
                  </div>
                </div>
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">תגובה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="material_sensitivity_info.reaction"
                        >
                          <option value="">בחר תגובה</option>
                          <option>פריחה</option>
                          <option>גירוד</option>
                          <option>קוצר נשימה</option>
                          <option>כאבי בטן</option>
                          <option>רעד</option>
                          <option>הקאות</option>
                          <option>שלשולים</option>
                          <option>חולשה</option>
                          <option>ירידה ב-PLT</option>
                          <option>ירידת לחץ דם</option>
                          <option>נפיחות</option>
                          <option>הלם אנפילקטי</option>
                          <option>שוק</option>
                          <option>אנגיואדמה</option>
                          <option>חנק</option>
                          <option>אודם</option>
                          <option>אפניאה</option>
                          <option>בצקת</option>
                          <option>פרכוס</option>
                          <option>לא ידוע</option>
                          <option>אחר</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">חומרה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="material_sensitivity_info.severity"
                        >
                          <option value="">בחר חומרה</option>
                          <option>קלה</option>
                          <option>בינוני</option>
                          <option>קשה</option>
                          <option>הלם</option>
                          <option>בספק</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם חומר (בעברית)*
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="material_sensitivity_info.name !== ''"
                          @click="material_sensitivity_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="material_sensitivity_info.name"
                          @search-change="
                            onSearch($event, 'material_sensitivity')
                          "
                          :options="material_sensitivity"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.material_sensitivity"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="material_sensitivity_info.notes"
                        placeholder="פירוט.."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <div class="add_new_row add_new_row_btns flex">
                    <div class="add_new_row_col1">
                      <a
                        class="add_task_width add_new_task flex flex--start"
                        href="javascript:void(0)"
                        @click="addBlock('material')"
                        ><span class="plus-circ flex flex--content--center"
                          ><span class="plus"></span
                        ></span>
                        הוספת רשומה</a
                      >
                    </div>
                    <div class="add_new_row_col2 desk-hide">
                      <a
                        class="add_new_task flex flex--end"
                        href=""
                        v-if="material_sensitivity_info_edit"
                        ><span class="trash">
                          <TrashSvg />
                        </span>
                        מחיקה</a
                      >
                    </div>
                    <div
                      class="error-message"
                      v-if="errorMessages.material.show"
                    >
                      {{ errorMessages.material.msg }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Stage 3  -->
            <!-- Stage 4 -->
            <div
              class="subtitle center no_mobile"
              v-if="stage === 4 || isMobile"
            >
              הזן כלים ועזרים לניתוח
            </div>
            <h2 v-show="isMobile" class="subtitle_inner" ref="surgHelpers">
              הזן כלים ועזרים לניתוח:
            </h2>
            <div class="required-txt" :class="{ center: !isMobile }">
              *כוכבית מסמלת את השדות הנדרשים לבחירה
            </div>
            <div
              v-if="stage === 4 || isMobile"
              class="inner_group bg--white desk_inner_width desk-flex desk-flex--top sanit-form"
            >
              <div class="add_new_row flex">
                <div class="add_new_row_col1">
                  אסיסטנט*
                  <span class="note mobile_only">בחר צורך באסיסטנט</span>
                </div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <validation-provider
                      name="assistant"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <select2 dir="rtl" v-model="surg.assistant">
                        <option value="">בחר</option>
                        <option
                          v-for="(option, i) in surgerySelect.assistant_status"
                          :key="i"
                          :value="option.value"
                        >
                          {{ option.text }}
                        </option>
                      </select2>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                  <span class="note no_mobile">בחר צורך באסיסטנט</span>
                </div>
              </div>
              <div
                class="add_new_row flex"
                :class="surg.assistant == 'מביא אסיסטנט' ? '' : 'disabled'"
              >
                <div class="add_new_row_col1">שם האסיסטנט</div>
                <div class="add_new_row_col2">
                  <div class="input-opacity">
                    <input
                      v-model="surg.assistant_name"
                      type="text"
                      :disabled="surg.assistant !== 'מביא אסיסטנט'"
                    />
                  </div>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">ימי אשפוז*</div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <validation-provider
                      name="hospitalization"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <select2 name="" dir="rtl" v-model="surg.hospitalization">
                        <option value="">בחר</option>
                        <option
                          v-for="(option, i) in surgerySelect.hospitalization"
                          :key="i"
                          :value="option.value"
                        >
                          {{ option.text }}
                        </option>
                      </select2>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">
                  הרדמה* <span class="note mobile_only">בחר צורך במרדים</span>
                </div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <validation-provider
                      name="anesthesia"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <select2 name="" dir="rtl" v-model="surg.anesthesia">
                        <option value="">בחר</option>
                        <option
                          v-for="(option, i) in surgerySelect.anesthesia"
                          :key="i"
                          :value="option.value"
                        >
                          {{ option.text }}
                        </option>
                      </select2>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                  <span class="note no_mobile">בחר צורך במרדים</span>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">סוג צילום</div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <select2 name="" dir="rtl" v-model="surg.xray_type">
                      <option value="">בחר</option>
                      <option
                        v-for="(option, i) in surgerySelect.xray_type"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </select2>
                  </div>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1">
                  חתך קפוא (FS)
                  <span class="note mobile_only"
                    >במידה ויש צורך בFS אנא בחר ביחס למועד הניתוח</span
                  >
                </div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <select2 name="" dir="rtl" v-model="surg.select_frozen_cut">
                      <option value="">בחר</option>
                      <option
                        v-for="(option, i) in surgerySelect.frozen_cut"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </select2>
                  </div>
                  <span class="note no_mobile"
                    >במידה ויש צורך בFS אנא בחר ביחס למועד הניתוח</span
                  >
                </div>
              </div>
              <div class="add_new_row sanit-order">
                <div class="flex step-4-docs-group">
                  <div class="add_new_row_col1 w-100">הזמנות</div>
                  <div class="add_new_row_col2 w-100">
                    <div
                      class="sur_order flex flex--start"
                      @click="
                        surg.requests.monitoring_request = !surg.requests
                          .monitoring_request
                      "
                    >
                      <a
                        class="sur_order_swipe"
                        href="javascript:void(0)"
                        :class="{ active: surg.requests.monitoring_request }"
                        ><span class="swipe_in ease"></span
                      ></a>
                      <div class="sur_order_tx">נדרש ניטור</div>
                    </div>
                    <div
                      class="sur_order flex flex--start"
                      @click="surg.requests.blood = !surg.requests.blood"
                    >
                      <a
                        class="sur_order_swipe"
                        href="javascript:void(0)"
                        :class="{ active: surg.requests.blood }"
                        ><span class="swipe_in ease"></span
                      ></a>
                      <div class="sur_order_tx">הזמנת מוצרי דם</div>
                    </div>
                    <div
                      class="sur_order flex flex--start"
                      @click="surg.requests.icu = !surg.requests.icu"
                    >
                      <a
                        class="sur_order_swipe"
                        href="javascript:void(0)"
                        :class="{ active: surg.requests.icu }"
                        ><span class="swipe_in ease"></span
                      ></a>
                      <div class="sur_order_tx">אשפוז בטיפול נמרץ</div>
                    </div>
                    <div
                      class="sur_order flex flex--start"
                      @click="
                        surg.requests.tee_request = !surg.requests.tee_request
                      "
                    >
                      <a
                        class="sur_order_swipe"
                        href="javascript:void(0)"
                        :class="{ active: surg.requests.tee_request }"
                        ><span class="swipe_in ease"></span
                      ></a>
                      <div class="sur_order_tx">נדרש T.E.E.</div>
                    </div>
                    <div
                      class="sur_order flex flex--start"
                      @click="
                        surg.requests.navigation_request = !surg.requests
                          .navigation_request
                      "
                    >
                      <a
                        class="sur_order_swipe"
                        href="javascript:void(0)"
                        :class="{ active: surg.requests.navigation_request }"
                        ><span class="swipe_in ease"></span
                      ></a>
                      <div class="sur_order_tx">נדרש ניווט</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="no_mobile sanit-notes is--fit">
                <div class="add_new_row flex step-4-docs-group">
                  <div class="add_new_row_col1 w-100">משאבים נדרשים</div>
                  <div class="input_area_opcity">
                    <textarea
                      v-model="surg.resources"
                      placeholder="פירוט..."
                      autocomplete="off"
                    ></textarea>
                  </div>
                </div>
                <div class="add_new_row flex step-4-docs-group">
                  <div class="add_new_row_col1 w-100">הערות</div>
                  <div class="input_area_opcity">
                    <textarea
                      v-model="surg.notes"
                      placeholder="פירוט.."
                      autocomplete="off"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="stage === 4 || isMobile"
              class="inner_group bg--white desk-hide"
            >
              <div class="add_new_row flex">
                <div class="add_new_row_col1 w-100">משאבים נדרשים</div>
                <div class="input_area_opcity">
                  <textarea
                    v-model="surg.resources"
                    placeholder="פירוט..."
                  ></textarea>
                </div>
              </div>
              <div class="add_new_row flex">
                <div class="add_new_row_col1 w-100">הערות</div>
                <div class="input_area_opcity">
                  <textarea
                    v-model="surg.notes"
                    placeholder="פירוט.."
                    autocomplete="off"
                  ></textarea>
                </div>
              </div>
            </div>

            <div
              v-if="stage === 4 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="this.isMobile ? '' : 'active'"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                onclick="toggle(this)"
              >
                <span class="title flex">
                  <span
                    >מסמכים מצורפים (ניתן להוסיף מסמך בסיומת pdf, jpg,
                    png)</span
                  >
                </span>
                <span class="plus-wrap flex m-flex--center"
                  ><span class="plus"></span
                ></span>
              </a>

              <div class="book_surgery_open toggleInner">
                <div
                  class="inner_group bg--white desk-no-pad desk-flex desk-flex--top desk-flex--start"
                >
                  <div
                    class="add_new_row_docs m-pt-15 flex flex--start svg-block"
                  >
                    <a
                      class="file_item relative flex desk-block"
                      v-for="(file, index) in surg.files"
                      href="javascript:void(0)"
                      :key="index"
                    >
                      <img
                        class="no_mobile"
                        src="/assets/img/svg/ic-file.svg"
                      />
                      <span class="tx_file block">{{ file.name }}</span>
                    </a>
                    <div
                      class="bt_upload relative flex desk-block"
                      @click="addDocuments"
                    >
                      <input type="text" />
                      <div class="ic-upload ease">
                        <UploadSvg />
                      </div>
                      <div class="tx_file ease">הוספת מסמך</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="error-message center" v-if="serverError">
              {{ serverError }}
            </div>
            <div v-if="stage !== 4 && !isMobile" class="form_submit center">
              <button class="bt_blue" @click.prevent="onNextStage">הבא</button>
            </div>
            <div v-show="stage === 4 || isMobile" class="form_submit center">
              <button type="submit" class="bt_blue">המשך לאישור</button>
            </div>
          </section>
        </form>
      </ValidationObserver>
    </div>
    <surg-approve
      v-show="isSurgConfirm"
      :surgery="surgToApprove"
      :files="surg.files"
      :filesType="filesType"
      :beforeEditFiles="beforeEditFiles"
      :isAfterEdit="editSurgery ? true : false"
      @approveGoBack="
        isSurgConfirm = false;
        stage = 4;
      "
    />
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
import TrashSvg from "@/assets/img/svg/trash.svg";
import UploadSvg from "@/assets/img/svg/upload.svg";
import PenSvg from "@/assets/img/svg/ic-pen.svg";
import ArrowBack from "../../../assets/img/svg/arrow_r.svg";
import AddDocuments from "@/components/Popups/AddDocuments";
import SurgSidesErr from "@/components/Popups/SurgSidesErr.vue";
import { mapActions, mapState, mapGetters } from "vuex";
// import VueTimepicker from "vue2-timepicker";
import SurgApprove from "./SurgApprove.vue";
import Cleave from "vue-cleave-component";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import surgerySelect from "../../../mixins/surgerySelect.json";
import { getHash } from "../../../utilities/hash.js";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "SurgAdd",
  props: {
    editSurgery: {
      default: () => null
    }
  },
  data() {
    return {
      surgerySelect,
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      isOnEditRow: false,
      editRow: {
        surgery: null,
        insurance: null,
        diagnosis: null,
        past_diagnosis: null,
        medication: null,
        material: null
      },
      beforeEditFiles: [],
      surgToApprove: null,
      isSurgConfirm: false,
      isInsuranceType: false,
      isHealty: false,
      stage: 2,
      code_query: "",
      serverError: "",
      surg_info: {
        side: "",
        category: "",
        code_name_hospital: "",
        code_name_clinical: "",
        duration: ""
      },
      insurance_info: {
        category: "",
        code: "",
        notes: ""
      },
      past_diagnosis: {
        side: "",
        diagnosis_number: "",
        diagnosis_name: "",
        notice: ""
      },
      errorMessages: {
        surgery: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        insurance: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        diagnosis: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        past_diagnosis: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        medication: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        material: {
          show: false,
          msg: "יש למלא את כל השדות"
        }
      },
      diagnosis_info: {
        side: "",
        code: "",
        name: "",
        notes: ""
      },
      medication_sensitivity_info: {
        reaction: "",
        severity: "",
        name: "",
        notes: ""
      },
      material_sensitivity_info: {
        reaction: "",
        severity: "",
        name: "",
        notes: ""
      },
      surgery_categories: [],
      surgery_codes: [],
      surgery_codes_auto: [],
      surgery_codes_clinic: [],
      surgery_codes_clinic_auto: [],
      current_diagnosis: [],
      past_diagnosis_options: [],
      medication_sensitivity: [],
      material_sensitivity: [],
      insurance_types: surgerySelect.insurance_types,
      insurance_surgery_categories: [],
      insurance_surgery_codes: [],
      material_sensitivity_info_edit: false,
      medication_sensitivity_info_edit: false,
      surge_info_edit: false,
      diagnosis_info_edit: false,
      insurance_info_edit: false,
      past_diagnosis_edit: false,
      surg: {
        id_num: this.$store.state.surg_patient.id_num,
        first_name: this.$store.state.surg_patient.first_name,
        last_name: this.$store.state.surg_patient.last_name,
        birth_date: null,
        parent_name: this.$store.state.surg_patient.apotropos || "",
        phone: this.$store.state.surg_patient.phone || "",
        phone2: this.$store.state.surg_patient.second_phone || "",
        lang: "",
        gender: this.$store.state.surg_patient.gender || "",
        selected_surgery: [],
        treatment_history: "",
        current_diagnosis: [],
        past_diagnosis: [],
        background_diagnosis: "",
        phisycal_check: "",
        no_drug_sens: false,
        no_material_sens: false,
        medication_sensitivity: [],
        material_sensitivity: [],
        insurance_surgery: [],
        assistant: "",
        assistant_name: "",
        hospitalization: "",
        anesthesia: "",
        xray_type: "",
        select_frozen_cut: "",
        requests: {
          monitoring_request: false,
          blood: false,
          icu: false,
          tee_request: false,
          navigation_request: false
        },
        doctor_fee: "",
        insurance_type: "",
        resources: "",
        notes: "",
        files: []
      },
      doctorHistory: null,
      limit: {
        current_surgery: 10,
        current_procedure: 10,
        current_diagnosis: 10,
        past_diagnosis: 10,
        medication_sensitivity: 10,
        material_sensitivity: 10,
        current_insurance: 10
      },
      filesType: "medicaldocuments-patient",
      disabledByAutocomplete: {
        clinical: false,
        hospital: false
      }
    };
  },
  async mounted() {
    if (
      this.$store.state.surg_patient.gender === "male" ||
      this.$store.state.surg_patient.gender === "זכר"
    ) {
      this.surg.gender = "male";
    } else if (
      this.$store.state.surg_patient.gender === "female" ||
      this.$store.state.surg_patient.gender === "נקבה"
    ) {
      this.surg.gender = "female";
    } else {
      this.surg.gender = "";
    }
    // history
    this.getHistory();

    this.$API.getTypehead("current_surgery_category").then(res => {
      this.surgery_categories = res;
    });

    // get insuarnce_types
    // const resInsuarnce = await this.$API.getTypehead("insuarnce_types");
    // let filtred = [];
    // resInsuarnce.forEach(item => {
    //   const find = filtred.find(i => i.insurance_code == item.insurance_code);
    //   if (!find) filtred.push(item);
    // });
    // this.insurance_types = filtred;

    // birth_date format
    this.surg.birth_date = this.$moment(
      this.$store.state.surg_patient.birth_date,
      "DD-MM-YYYY"
    ).format("DD/MM/YYYY");

    // For Edit surg
    if (this.editSurgery) {
      this.surg = this.editSurgery;
      this.beforeEditFiles = JSON.parse(JSON.stringify(this.surg.files));
      // checkbox past_diagnosis
      this.isHealty = this.editSurgery.checkbox_past_diagnosis;
      if (this.isHealty) this.surg.background_diagnosis = "healthy";
      // surg.insurance_type
      this.isInsuranceType = false;
      const findSI = this.insurance_types.find(
        t => t.insurance_name === this.surg.insurance_type
      );
      if (!findSI) return;
      const types = ["1240", "1249", "1239", "1007", "1017"];
      if (types.includes(findSI.insurance_code)) {
        const id = parseInt(findSI.insurance_code);
        this.$API
          .getTypehead("insurance_surgery_category", null, id)
          .then(res => {
            this.insurance_surgery_categories = res.map(
              r => r.insurance_category_name
            );
          });
        this.$API.getTypehead("insurance_surgery", null, id).then(res => {
          const tmp = res.map(r => r.surgery_name);
          this.insurance_surgery_codes = this.getTypeheadHistory(
            tmp,
            "current_insurance"
          );
        });
        this.isInsuranceType = true;
      }
    }

    // Listen if added documents
    this.$root.$on("uploadSurgFiles", ev => {
      this.surg.files = [...this.surg.files, ...ev.files];
      this.filesType = ev.type;
    });
  },
  watch: {
    editSurgery(val) {
      this.surg = val;
    },
    "surg.insurance_type"(val) {
      this.isInsuranceType = false;
      const findSI = this.insurance_types.find(t => t.insurance_name === val);
      if (!findSI) return;
      const types = ["1240", "1249", "1239", "1007", "1017"];
      if (types.includes(findSI.insurance_code)) {
        const id = parseInt(findSI.insurance_code);
        this.$API
          .getTypehead("insurance_surgery_category", null, id)
          .then(res => {
            this.insurance_surgery_categories = res.map(
              r => r.insurance_category_name
            );
          });
        this.$API.getTypehead("insurance_surgery", null, id).then(res => {
          const tmp = res.map(r => r.surgery_name);
          this.insurance_surgery_codes = this.getTypeheadHistory(
            tmp,
            "current_insurance"
          );
        });
        this.isInsuranceType = true;
      }
    },
    "surg_info.code_name_hospital"(val) {
      if (!val) {
        this.disabledByAutocomplete.clinical = false;
        return;
      }
      this.$API
        .getTypehead(
          "surgery_duration",
          null,
          null,
          this.activeDoctor.license,
          val
        )
        .then(res => {
          if (res) {
            this.surg_info.duration = this.$moment(res, "H:mm").format("HH:mm");
            this.$refs.surgform.reset();
          }
        });
      if (this.surg_info.code_name_clinical) return;
      const code = val.split(" > ")[0].replace(/\s/g, "");
      this.$API
        .getAutocompleteSurgCode("tafnit_to_chameleon", code)
        .then(res => {
          this.surgery_codes_clinic_auto = [];
          this.disabledByAutocomplete.clinical = false;
          if (res && res.length) {
            if (res.length == 1) {
              this.surg_info.code_name_clinical = res[0].name;
              this.disabledByAutocomplete.clinical = true;
            } else {
              const tmp = res.map(item => item.name);
              this.surgery_codes_clinic_auto = tmp;
            }
          }
        });
    },
    "surg_info.code_name_clinical"(val) {
      if (!val || this.surg_info.code_name_hospital) {
        this.disabledByAutocomplete.hospital = false;
        return;
      }
      const code = val.split(" > ")[0].replace(/\s/g, "");
      this.$API
        .getAutocompleteSurgCode("chameleon_to_tafnit", code)
        .then(res => {
          this.surgery_codes_auto = [];
          this.disabledByAutocomplete.hospital = false;
          if (res && res.length) {
            if (res.length == 1) {
              this.surg_info.code_name_hospital = res[0].name;
              this.disabledByAutocomplete.hospital = true;
            } else {
              const tmp = res.map(item => item.name);
              this.surgery_codes_auto = tmp;
            }
          }
        });
    },
    "surg_info.duration"(val) {
      if (!val) this.surg_info.duration = "HH:mm";
    },
    "surg.no_drug_sens"(value) {
      if (value) this.surg.medication_sensitivity = [];
    },
    "surg.no_material_sens"(value) {
      if (value) this.surg.material_sensitivity = [];
    },
    "surg_info.category"(val) {
      if (this.isOnEditRow) return;
      // reset
      this.surgery_codes = [];
      this.surgery_codes_auto = [];
      this.surgery_codes_clinic = [];
      this.surgery_codes_clinic_auto = [];
      this.surg_info.code_name_clinical = "";
      this.surg_info.code_name_hospital = "";

      if (val) {
        // api with category
        this.$API.getTypehead("current_surgery", parseInt(val)).then(res => {
          const tmp = res.map(r => r.surgery_eng_name);
          this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
        });

        this.$API.getTypehead("current_procedure", parseInt(val)).then(res => {
          const map = res.map(r => r.procedure);
          const tmp = [...new Set(map)];
          this.surgery_codes_clinic = this.getTypeheadHistory(
            tmp,
            "current_procedure"
          );
        });
      } else {
        // api witout category
        this.$API.getTypehead("current_surgery").then(res => {
          const tmp = res.map(r => r.surgery_eng_name);
          this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
        });

        this.$API.getTypehead("current_procedure").then(res => {
          const map = res.map(r => r.procedure);
          const tmp = [...new Set(map)];
          this.surgery_codes_clinic = this.getTypeheadHistory(
            tmp,
            "current_procedure"
          );
        });
      }
    },
    "past_diagnosis.diagnosis_name"(val) {
      this.past_diagnosis.diagnosis_number = val.substring(0, val.indexOf(" "));
    },
    "diagnosis_info.name"(val) {
      this.diagnosis_info.code = val.substring(0, val.indexOf(" "));
    },
    "surg.assistant"(val) {
      if (val != "מביא אסיסטנט") this.surg.assistant_name = "";
    },
    activeDoctor() {
      this.getHistory();
    }
  },
  computed: {
    ...mapState(["saveSurgery", "user_passport"]),
    ...mapGetters(["activeDoctor"]),
    // filteredCodes() {
    //   let data = this.surgery_codes.filter(option => {
    //     return (
    //       option.surgery_eng_name
    //         .toLowerCase()
    //         .indexOf(this.code_query.toLowerCase()) > -1
    //     );
    //   });
    //   return [{ data: data }];
    // },
    isMobile() {
      return window && window.innerWidth < 1200 ? true : false;
    }
  },
  methods: {
    ...mapActions(["SET_SURGERY"]),
    addDocuments() {
      this.$modal.show(AddDocuments);
    },
    onCleave(ev) {
      if (ev) {
        this.surg_info.duration =
          ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
      } else {
        this.surg_info.duration = ev;
      }
    },
    onPrevStage() {
      this.$refs.surgform.reset();
      for (const key in this.errorMessages) {
        this.errorMessages[key].show = false;
      }
      if (this.stage === 2) {
        this.$router.push("surg-add");
      } else if (this.stage > 2) {
        this.stage--;
      }
    },
    async onNextStage() {
      if (this.stage === 3) {
        await this.addBlockDefault();
      }
      const res = await this.$refs.surgform.validate();
      let elementScroll;

      if (this.stage === 3) {
        const sidesRes = this.checkSurgerySides();

        if (!sidesRes) {
          this.$modal.show(SurgSidesErr);
          return;
        }

        if (!this.surg.selected_surgery || !this.surg.selected_surgery.length) {
          this.errorMessages.surgery.show = true;
          elementScroll = "selected_surgery";
        }
        if (this.$refs.surgform.errors.insurance_type.length) {
          if (!elementScroll) elementScroll = "insuranceType";
        }
        if (this.isInsuranceType && this.errorMessages.insurance.show) {
          if (!elementScroll) elementScroll = "insuranceSurg";
        }
        if (this.errorMessages.diagnosis.show) {
          if (!elementScroll) elementScroll = "currentDiagnosis";
        }
        if (
          !this.isHealty &&
          (!this.surg.past_diagnosis || !this.surg.past_diagnosis.length)
        ) {
          this.errorMessages.past_diagnosis.show = true;
          if (!elementScroll) elementScroll = "past_diagnosis";
        }
        if (this.$refs.surgform.errors.phisycal_check.length) {
          if (!elementScroll) elementScroll = "phisycal_check";
        }
      }

      if (elementScroll) {
        const element = this.$refs[elementScroll];
        if (element && element.offsetTop) {
          setTimeout(() => {
            window.scrollTo({
              top: element.offsetTop,
              left: 0,
              behavior: "smooth"
            });
            elementScroll = "";
          }, 100);
          return;
        }
      }

      if (
        (res && this.stage != 3) ||
        (this.stage == 3 &&
          !this.$refs.surgform._data.errors.insurance_type.length &&
          !this.$refs.surgform._data.errors.phisycal_check.length)
      ) {
        this.stage++;
        window.scrollTo(0, 0);
      }
    },
    onHealty() {
      this.isHealty = !this.isHealty;
      if (this.isHealty) this.surg.background_diagnosis = "healthy";
      else this.surg.background_diagnosis = "";
    },
    async confirmSurg() {
      //this.$router.push({ name: "surg-confirm" });
      this.serverError = "";
      if (this.isMobile) await this.addBlockDefault();
      let res = await this.$refs.surgform.validate();
      if (this.isMobile) {
        const sidesRes = this.checkSurgerySides();
        if (!sidesRes) {
          this.$modal.show(SurgSidesErr);
          return;
        }

        const mobileValid = await this.errScroll(res);
        if (!mobileValid) return;
      }

      if (res) {
        let surgery_obj = {
          form_type: "modal",
          surgery_id: "",
          block_id: "",
          start_surgery: "",
          end_surgery: "",
          doctor_id: this.activeDoctor.id,
          passport: this.surg.id_num,
          first_name: this.surg.first_name,
          last_name: this.surg.last_name,
          birth_date: this.$moment(this.surg.birth_date, "DD/MM/YYYY").format(
            "DD-MM-YYYY"
          ),
          gender: this.surg.gender,
          phone: this.surg.phone,
          user_language: this.surg.lang,
          second_phone: this.surg.phone2,
          apotropos_name: this.surg.parent_name,
          current_surgery: [],
          indication: this.surg.treatment_history,
          current_diagnosis: [],
          checkbox_past_diagnosis: this.isHealty ? 1 : null,
          past_diagnosis: [],
          physical_examination: this.surg.phisycal_check,
          checkbox_medication_sensitivity: this.surg.no_drug_sens ? 1 : null,
          medication_sensitivity: [],
          checkbox_material_sensitivity: this.surg.no_material_sens ? 1 : null,
          material_sensitivity: [],
          insurance_surgery: [],
          insurance_name: this.surg.insurance_type,
          doctor_fee: this.surg.doctor_fee,
          assistant_status: this.surg.assistant,
          assistant_name: this.surg.assistant_name,
          hospitalization: this.surg.hospitalization,
          resources: this.surg.resources,
          notes: this.surg.notes,
          frozen_cut: this.surg.select_frozen_cut,
          xray_type: this.surg.xray_type,
          monitoring_request: this.surg.requests.monitoring_request ? "כן" : "",
          blood: this.surg.requests.blood ? "כן" : "",
          icu: this.surg.requests.icu ? "כן" : "",
          tee_request: this.surg.requests.tee_request ? "כן" : "",
          navigation_request: this.surg.requests.navigation_request ? "כן" : "",
          anesthesia: this.surg.anesthesia
        };
        const passport_type = this.editSurgery
          ? this.editSurgery.passport_type
          : this.$store.state.surg_patient.passport_type;
        if (passport_type) surgery_obj.passport_type = passport_type;
        this.surg.selected_surgery.map(s => {
          surgery_obj.current_surgery.push({
            surgery_category: s.category,
            procedure: s.code_name_clinical,
            surgery_name: s.code_name_hospital,
            surgery_duration: s.duration,
            side: s.side
          });
        });
        this.surg.current_diagnosis.map(diagnosis => {
          surgery_obj.current_diagnosis.push({
            side: diagnosis.side,
            diagnosis_number: diagnosis.code,
            diagnosis_name: diagnosis.name,
            notice: diagnosis.notes
          });
        });
        this.surg.past_diagnosis.map(diagnosis => {
          surgery_obj.past_diagnosis.push({
            side: diagnosis.side,
            diagnosis_number: diagnosis.diagnosis_number,
            diagnosis_name: diagnosis.diagnosis_name,
            notice: diagnosis.notice
          });
        });
        this.surg.medication_sensitivity.map(sens => {
          surgery_obj.medication_sensitivity.push({
            response: sens.reaction,
            severity: sens.severity,
            medication: sens.name,
            notice: sens.notes
          });
        });
        this.surg.material_sensitivity.map(material => {
          surgery_obj.material_sensitivity.push({
            response: material.reaction,
            severity: material.severity,
            material_name: material.name,
            notice: material.notes
          });
        });
        this.surg.insurance_surgery.map(insurance => {
          surgery_obj.insurance_surgery.push({
            insurance: this.surg.insurance_type,
            surgery_category: insurance.category,
            surgery_name: insurance.code,
            notice: insurance.notes
          });
        });
        // surgery_obj.surgery_id = "";
        if (this.editSurgery) {
          surgery_obj.surgery_id = this.$route.params.id;
        }
        this.surgToApprove = surgery_obj;
        this.isSurgConfirm = true;
        this.$refs.surgform.reset();
        for (const key in this.errorMessages) {
          this.errorMessages[key].show = false;
        }
        // this.SET_SURGERY(surgery_obj);
        // this.$router.push("/surg-confirm");
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    },
    getCategoryNameByCode(code) {
      let find = this.surgery_categories.find(
        cat => cat.current_surgery_category_code == code
      );
      if (typeof find != "undefined") {
        return find.current_surgery_category_name;
      }
      return "";
    },
    getInsuranceCategoryNameByCode(code) {
      let find = this.insurance_surgery_categories.find(
        cat => cat.insurance_category_code == code
      );
      if (find) return find.insurance_category_name;
      return "";
    },
    validateObjectData(object) {
      let flag = true;
      for (const key in object) {
        if (key == "duration" && object[key] == "HH:mm") {
          flag = false;
        }
        if (
          key !== "notes" &&
          key !== "notice" &&
          key !== "category" &&
          key !== "side" &&
          object[key] == ""
        ) {
          flag = false;
        }
      }
      return flag;
    },
    async addBlock(block_type) {
      const isAddFromEdit = this.editRow[block_type] != null;
      if (typeof block_type == "undefined" || !block_type) return;
      let object = {};
      for (const key in this.errorMessages) {
        this.errorMessages[key].show = false;
      }
      this.surge_info_edit = this.material_sensitivity_info_edit = this.medication_sensitivity_info_edit = this.diagnosis_info_edit = this.insurance_info_edit = false;
      switch (block_type) {
        case "surgery":
          const res = await this.$refs.end_time.validate();
          if (res && res.valid) {
            object = Object.assign({}, this.surg_info);
            if (!this.validateObjectData(object)) {
              this.errorMessages.surgery.show = true;
              break;
            }
            this.surg.selected_surgery.splice(
              isAddFromEdit
                ? this.editRow[block_type]
                : this.surg.selected_surgery.length,
              0,
              object
            );
            for (const key in this.surg_info) {
              this.surg_info[key] = "";
            }
          } else {
            this.errorMessages.surgery.show = true;
          }
          break;
        case "insurance":
          object = Object.assign({}, this.insurance_info);
          if (!this.validateObjectData(object)) {
            this.errorMessages.insurance.show = true;
            break;
          }
          this.surg.insurance_surgery.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.insurance_surgery.length,
            0,
            object
          );
          for (const key in this.insurance_info) {
            this.insurance_info[key] = "";
          }
          break;
        case "diagnosis":
          object = Object.assign({}, this.diagnosis_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.diagnosis.show = true;
            break;
          }
          this.surg.current_diagnosis.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.current_diagnosis.length,
            0,
            object
          );
          for (const key in this.diagnosis_info) {
            this.diagnosis_info[key] = "";
          }
          break;
        case "past_diagnosis":
          object = Object.assign({}, this.past_diagnosis);
          if (!this.validateObjectData(object)) {
            this.errorMessages.past_diagnosis.show = true;
            break;
          }
          this.surg.past_diagnosis.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.past_diagnosis.length,
            0,
            object
          );
          for (const key in this.past_diagnosis) {
            this.past_diagnosis[key] = "";
          }
          break;
        case "medication":
          object = Object.assign({}, this.medication_sensitivity_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.medication.show = true;
            break;
          }
          this.surg.medication_sensitivity.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.medication_sensitivity.length,
            0,
            object
          );
          for (const key in this.medication_sensitivity_info) {
            this.medication_sensitivity_info[key] = "";
          }
          break;
        case "material":
          object = Object.assign({}, this.material_sensitivity_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.material.show = true;
            break;
          }
          this.surg.material_sensitivity.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.material_sensitivity.length,
            0,
            object
          );
          for (const key in this.material_sensitivity_info) {
            this.material_sensitivity_info[key] = "";
          }
          break;
      }
      if (isAddFromEdit) this.editRow[block_type] = null;
    },
    // onRow(type) {
    //   let isOn = true;
    //   for (const key in this[type]) {
    //     if (!this[type][key]) isOn = false;
    //   }
    //   return isOn;
    // },
    editSelectedBlock(block_type, index) {
      this.editRow[block_type] = index;
      this.isOnEditRow = true;
      let object = {};
      // let isOnEdit;
      switch (block_type) {
        case "surgery":
          // isOnEdit = this.onRow("surg_info");
          // if (isOnEdit) this.addBlock(block_type);
          object = Object.assign({}, this.surg.selected_surgery[index]);
          this.surg.selected_surgery.splice(index, 1);
          this.surg_info = object;
          this.surge_info_edit = true;
          break;
        case "insurance":
          object = Object.assign({}, this.surg.insurance_surgery[index]);
          this.surg.insurance_surgery.splice(index, 1);
          this.insurance_info = object;
          this.insurance_info_edit = true;
          break;
        case "diagnosis":
          object = Object.assign({}, this.surg.current_diagnosis[index]);
          this.surg.current_diagnosis.splice(index, 1);
          this.diagnosis_info = object;
          this.diagnosis_info_edit = true;
          break;
        case "past_diagnosis":
          object = Object.assign({}, this.surg.past_diagnosis[index]);
          this.surg.past_diagnosis.splice(index, 1);
          this.past_diagnosis = object;
          this.past_diagnosis_edit = true;
          break;
        case "medication":
          object = Object.assign({}, this.surg.medication_sensitivity[index]);
          this.surg.medication_sensitivity.splice(index, 1);
          this.medication_sensitivity_info = object;
          this.medication_sensitivity_info_edit = true;
          break;
        case "material":
          object = Object.assign({}, this.surg.material_sensitivity[index]);
          this.surg.material_sensitivity.splice(index, 1);
          this.material_sensitivity_info = object;
          this.material_sensitivity_info_edit = true;
          break;
      }
      setTimeout(() => {
        this.isOnEditRow = false;
      }, 500);
    },
    removeSelectedBlock(block_type, index) {
      if (this.editRow[block_type] && index < this.editRow[block_type]) {
        this.editRow[block_type]--;
      }
      switch (block_type) {
        case "surgery":
          this.surg.selected_surgery.splice(index, 1);
          break;
        case "insurance":
          this.surg.insurance_surgery.splice(index, 1);
          break;
        case "diagnosis":
          this.surg.current_diagnosis.splice(index, 1);
          break;
        case "past_diagnosis":
          this.surg.past_diagnosis.splice(index, 1);
          break;
        case "medication":
          this.surg.medication_sensitivity.splice(index, 1);
          break;
        case "material":
          this.surg.material_sensitivity.splice(index, 1);
          break;
      }
    },
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    async errScroll(res = true) {
      const errors = this.$refs.surgform.errors;
      if (
        errors.birth_date.length ||
        errors.first_name.length ||
        errors.last_name.length ||
        errors.phone.length ||
        errors.gender.length
      ) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        return false;
      }
      let elementScroll;
      if (
        !this.surg.selected_surgery ||
        !this.surg.selected_surgery.length ||
        this.errorMessages.surgery.show
      ) {
        this.errorMessages.surgery.show = true;
        elementScroll = "selected_surgery";
      }
      if (this.$refs.surgform.errors.insurance_type.length) {
        if (!elementScroll) elementScroll = "insuranceType";
      }
      if (this.isInsuranceType && this.errorMessages.insurance.show) {
        this.errorMessages.insurance.show = true;
        if (!elementScroll) elementScroll = "insuranceSurg";
      }
      if (this.errorMessages.diagnosis.show) {
        if (!elementScroll) elementScroll = "currentDiagnosis";
      }
      if (
        !this.isHealty &&
        (!this.surg.past_diagnosis ||
          !this.surg.past_diagnosis.length ||
          this.errorMessages.past_diagnosis.show)
      ) {
        this.errorMessages.past_diagnosis.show = true;
        if (!elementScroll) elementScroll = "past_diagnosis";
      }
      if (this.$refs.surgform.errors.phisycal_check.length) {
        if (!elementScroll) elementScroll = "phisycal_check";
      }
      if (elementScroll) {
        const element = this.$refs[elementScroll];
        const top = this.isMobile ? element.offsetTop - 56 : element.offsetTop;
        // if (this.isMobile) element.classList.add("active");
        // await element.scrollIntoView({ behavior: "smooth" });
        window.scrollTo({
          top: top,
          left: 0,
          behavior: "smooth"
        });
        elementScroll = "";
        return false;
      }
      if (!res && this.isMobile) {
        const element = this.$refs.surgHelpers;
        window.scrollTo({
          top: element.offsetTop - 56,
          left: 0,
          behavior: "smooth"
        });
        return false;
      }
      return true;
    },
    addBlockDefault() {
      for (const key in this.surg_info) {
        if (this.surg_info[key] && this.surg_info[key] != "HH:mm") {
          this.addBlock("surgery");
          break;
        }
      }
      for (const key in this.insurance_info) {
        if (this.insurance_info[key]) {
          this.addBlock("insurance");
          break;
        }
      }
      for (const key in this.diagnosis_info) {
        if (this.diagnosis_info[key]) {
          this.addBlock("diagnosis");
          break;
        }
      }
      for (const key in this.past_diagnosis) {
        if (this.past_diagnosis[key]) {
          this.addBlock("past_diagnosis");
          break;
        }
      }
      for (const key in this.medication_sensitivity_info) {
        if (this.medication_sensitivity_info[key]) {
          this.addBlock("medication");
          break;
        }
      }
      for (const key in this.material_sensitivity_info) {
        if (this.material_sensitivity_info[key]) {
          this.addBlock("material");
          break;
        }
      }
    },
    async getHistory() {
      if (!this.activeDoctor || !this.activeDoctor.id) return;
      const resHistory = await this.$API.getDoctorHistory(this.activeDoctor.id);
      if (resHistory) this.doctorHistory = resHistory;

      this.$API.getTypehead("current_surgery").then(res => {
        const tmp = res.map(r => r.surgery_eng_name);
        this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
      });

      this.$API.getTypehead("current_procedure").then(res => {
        const map = res.map(r => r.procedure);
        const tmp = [...new Set(map)];
        this.surgery_codes_clinic = this.getTypeheadHistory(
          tmp,
          "current_procedure"
        );
      });

      this.$API.getTypehead("current_diagnosis").then(res => {
        const tmp = res.map(r => r.diagnosis);
        const tmp2 = [...tmp];
        this.current_diagnosis = this.getTypeheadHistory(
          tmp,
          "current_diagnosis"
        );
        this.past_diagnosis_options = this.getTypeheadHistory(
          tmp2,
          "past_diagnosis"
        );
      });

      this.$API.getTypehead("medication_sensitivity").then(res => {
        const tmp = res.map(r => r.name);
        this.medication_sensitivity = this.getTypeheadHistory(
          tmp,
          "medication_sensitivity"
        );
      });

      this.$API.getTypehead("material_sensitivity").then(res => {
        const tmp = res.map(r => r.name);
        this.material_sensitivity = this.getTypeheadHistory(
          tmp,
          "material_sensitivity"
        );
      });
    },
    getTypeheadHistory(resArr, type) {
      if (
        !this.doctorHistory ||
        !this.doctorHistory[type] ||
        !this.doctorHistory[type].length
      )
        return resArr;
      let historyArr = this.doctorHistory[type];
      historyArr = historyArr.filter(item => resArr.includes(item));
      if (historyArr && historyArr.length) this.limit[type] = historyArr.length;
      const filtred = resArr.filter(item => !historyArr.includes(item));
      return [...historyArr, ...filtred];
    },
    limitTypehead(type) {
      if (
        !this.doctorHistory ||
        !this.doctorHistory[type] ||
        !this.doctorHistory[type].length
      )
        return 10;
      return this.doctorHistory[type].length;
    },
    onSearch(ev, type) {
      if (ev) this.limit[type] = 10;
      else this.limit[type] = this.limitTypehead(type);
    },
    resetValue(type) {
      this.surg_info[type] = "";
      if (
        type == "code_name_hospital" &&
        this.disabledByAutocomplete.clinical
      ) {
        this.surg_info.code_name_clinical = "";
      }
      if (
        type == "code_name_clinical" &&
        this.disabledByAutocomplete.hospital
      ) {
        this.surg_info.code_name_hospital = "";
      }
    },
    isEnglish(text) {
      const englishRegex = /^[A-Za-z0-9\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/;
      return englishRegex.test(text);
    },
    checkSurgerySides() {
      if (!this.surg.selected_surgery || !this.surg.selected_surgery.length)
        return true;
      let groupedByCodeHospital = this.surg.selected_surgery.reduce(
        (acc, item) => {
          const key = item.code_name_hospital;
          acc[key] = acc[key] || [];
          acc[key].push(item);
          return acc;
        },
        {}
      );

      groupedByCodeHospital = Object.fromEntries(
        Object.entries(groupedByCodeHospital).filter(
          ([key, value]) => value.length > 1
        )
      );

      return Object.values(groupedByCodeHospital).every(items =>
        items.some(item => item.side === "") ? false : true
      );
    }
  },
  components: {
    CloseSvg,
    TrashSvg,
    UploadSvg,
    PenSvg,
    ArrowBack,
    // VueTimepicker,
    SurgApprove,
    Cleave,
    Multiselect
  }
};
</script>

<style>
.autosuggest__results-container ul,
.autosuggest__results-container li {
  padding: 0;
  display: block;
}

.vs__actions {
  display: none !important;
}

.add_task_width {
  width: 130px;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.required-txt {
  padding: 0 12px 12px;
  color: #b00020;
}

.center {
  text-align: center;
}

.surg-clear-btn {
  padding: 5px;
  font-size: 0.85rem;
  position: absolute;
  top: 22px;
  left: 20px;
  z-index: 1;
  cursor: pointer;
  background-color: rgb(240 240 240);
}

.btn-mobile {
  background-color: white;
  top: 14px;
  left: 0px;
}

.surg-side-note {
  width: 250px;
  display: block;
}
</style>
